// Angular Files
import {
 Component, EventEmitter, Input, Output
} from '@angular/core';

@Component({
    selector: 'app-full-page-dialog-header',
    templateUrl: './full-page-dialog-header.component.html',
    styleUrls: ['./full-page-dialog-header.component.scss'],
    host: {
        class: 'full-page-dialog-header'
    },
    standalone: false
})
export class FullPageDialogHeaderComponent {
    @Input() public title: string;

    @Input() public subtitle: string;

    // Leading nav icon. Defaults to a close (X) per the M3 full-screen-dialog spec; set to a
    // back arrow ('arrow_back') for dialogs that read as a navigation step rather than a dismiss.
    @Input() public leadingIcon: string = 'close';

    @Input() public ariaId: string = 'aria_modal_header';

    @Input() public closeAriaLabel: string = 'Close';

    @Output() public closed = new EventEmitter<void>();
}
